import React from "react";
import { Link } from "react-router-dom";
import { FaqCard } from "./HomeFAQ";

export default function FAQSection({
  background = "bg-brand-50",
  sections = [],
  pageTitle = "Frequently Asked Questions",
}) {
  return (
    <section className={`py-12 sm:py-16 ${background}`} data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        {pageTitle && (
          <div className="text-center mb-10 reveal">
            <h2 className="font-display text-3xl sm:text-4xl text-brand-900 text-balance">
              {pageTitle}
            </h2>
          </div>
        )}

        <div className="space-y-6">
          {sections.map((section, i) => (
            <FaqCard key={section.key} section={section} idx={i} />
          ))}
        </div>

        <p className="mt-10 text-center text-brand-900/60 reveal">
          Please reach out to us at{" "}
          <Link to="/contact" className="font-semibold text-teal-600 hover:text-teal-800 underline underline-offset-4 transition-colors" data-testid="faq-contact-link">
            AwareHub
          </Link>{" "}
          if you cannot find an answer to your question.
        </p>
      </div>
    </section>
  );
}
